import React, { PropTypes } from 'react';
import ProductHeader from './ProductHeader';

const wrapIfFixed = (fixed, children) => {
  if (fixed) {
    return <div className="wrapTh">{children}</div>;
  } else {
    return children;
  }
};

const ScoringTabHeader = ({
  products,
  createExclusion,
  deleteExclusion,
  fixed,
  fixMargin,
}) =>
  wrapIfFixed(
    fixed,
    <div className="tr" style={{ marginLeft: fixMargin }}>
      <div className="th question">Question</div>
      <div className="th response">Reponse</div>
      {products.map(product => (
        <ProductHeader
          key={product.id}
          product={product}
          exclusions={product.exclusions}
          onCreateExclusion={createExclusion}
          onDeleteExclusion={deleteExclusion}
        />
      ))}
    </div>
  );

ScoringTabHeader.propTypes = {
  products: PropTypes.array.isRequired,
  createExclusion: PropTypes.func.isRequired,
  deleteExclusion: PropTypes.func.isRequired,
  fixed: PropTypes.bool.isRequired,
  fixMargin: PropTypes.string.isRequired,
};

export default ScoringTabHeader;



// WEBPACK FOOTER //
// ./src/modules/funnel/components/detail/scoring/ScoringTabHeader.js